const DATE_RANGE_30 = '[0, 30]';
const DATE_RANGE_60 = '[0, 60]';
const DATE_RANGE_90 = '[0, 90]';
const DATE_RANGE_CUSTOM = 0;

export default [
  { value: DATE_RANGE_30, label: '0-30 days' },
  { value: DATE_RANGE_60, label: '0-60 days' },
  { value: DATE_RANGE_90, label: '0-90 days' },
  { value: DATE_RANGE_CUSTOM, label: 'Custom' }
];
